module.exports = __webpack_public_path__ + "assets/img/img331.4ef57b78.png";